import LoadMorePagination from './load-more-pagination'
import Pagination from './pagination.vue'

export default {
  LoadMorePagination,
  Pagination
}
